import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import ModalPortal from "../../utility/ModalPortal";
import Release from "./Release";
import Sharelink from "./Sharelink";
import formatDate from "../../util";
import { togglePriority } from "../../actions/postAction";

import "./Note.css";
import "./Note.dark.css";

function Note({ post, dark = false, isOwner = true }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const [showPopup, setShowPopup] = useState(false);
  const [showShareLink, setShowShareLink] = useState(false);
  const [priorityLoading, setPriorityLoading] = useState(false);
  const [flashPriority, setFlashPriority] = useState(false);

  const handleCardClick = () => {
    navigate(`/dashboard/note-details/${post._id}`, { state: { from: "nodes" } });
  };

  const handleRelease = (e) => {
    e.stopPropagation();
    setShowPopup(true);
    document.body.style.overflow = "hidden";
  };

  const isThoughtsEmpty = post.category === "Thoughts" && (!post.note || !post.note.trim());

  const handlePriorityToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (priorityLoading) return;

    setPriorityLoading(true);

    const success = await dispatch(
      togglePriority(post._id, post.isPriority)
    );

    if (success && !post.isPriority) {
      setFlashPriority(true);
      setTimeout(() => setFlashPriority(false), 800);
    }

    setPriorityLoading(false);
  };

  const statusLabel =
    post.status === "released"
      ? "Released"
      : post.status === "active"
      ? "Active"
      : "Standby";

  const formattedDate = formatDate(new Date(post.date));

  const showPriorityStar = Boolean(post.planId);

  return (
    <>
      <div
        className={`note-item ${post.status} ${dark ? "note-item-dark" : ""} ${post.isPriority ? "priority" : ""} ${flashPriority ? "priority-flash" : ""}`}
        onClick={handleCardClick}
        role="link"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === "Enter") handleCardClick(); }}
        style={{ cursor: "pointer" }}
      >

        {/* META ROW */}
        <div className="note-item-meta">
          <span className={`note-item-status ${post.status}`}>
            <span className="note-item-dot" />
            {statusLabel}
          </span>

          {post.updates?.length > 0 && (
            <span className="note-item-updates">
              {post.updates.length} {post.updates.length === 1 ? "update" : "updates"}
            </span>
          )}

          <span className="note-item-date">{formattedDate}</span>
        </div>

        {/* TEXT */}
        <div className={`note-item-text ${isThoughtsEmpty ? "note-item-text-thoughts" : ""}`}>
          {isThoughtsEmpty
            ? "your thoughts thread..."
            : post.note && post.note.length > 220
              ? post.note.substring(0, 220) + "…"
              : post.note}
        </div>

        {/* ACTIONS ROW */}
        <div className="note-item-actions" onClick={(e) => e.stopPropagation()}>

          {isOwner &&showPriorityStar && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  {post.isPriority ? "Remove priority" : "Mark as priority"}
                </Tooltip>
              }
            >
              <button
                className={`icon-btn priority-star ${post.isPriority ? "active" : ""}`}
                onClick={handlePriorityToggle}
                disabled={priorityLoading}
                aria-label="Toggle priority"
              >
                ★
              </button>
            </OverlayTrigger>
          )}

          <div className="note-item-actions-right">  {/* ← wrap release in this */}
            {post.status === "released" ? (
              <button className="note-item-btn released" disabled>Released</button>
            ) : (
              <button className="note-item-btn outline" onClick={handleRelease}>
                {post.method === "digicoins" ? "Release" : "Change status"}
              </button>
            )}
          </div>

        </div>

      </div>

      {/* RELEASE MODAL */}
      {showPopup && (
        <ModalPortal>
          <div className="overlay">
            <Release setShowPopup={setShowPopup} post={post} user={user} />
          </div>
        </ModalPortal>
      )}

      {/* SHARE MODAL */}
      {showShareLink && (
        <ModalPortal>
          <div className="overlay">
            <Sharelink setshowsharelink={setShowShareLink} postId={post._id} />
          </div>
        </ModalPortal>
      )}
    </>
  );
}

export default Note;